const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

const usdCompactFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  notation: "compact",
});

export function formatCurrency(
  value: number | string | null | undefined,
): string {
  if (value == null || value === "") return "$0.00";
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "$0.00";
  return usdFormatter.format(num);
}

export function formatCurrencyCompact(
  value: number | string | null | undefined,
): string {
  if (value == null || value === "") return "$0";
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "$0";
  return usdCompactFormatter.format(num);
}
